import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import React, { useCallback, useEffect, useRef } from 'react';
import { Field, useFormikContext } from 'formik';
import _ from 'lodash';
import { Country, State as StateEnum } from '@tradingblock/types';
import { TextboxField, SelectDropdownField } from './';
import { FormGroup } from '../../basic';
import { triggerUspsVerification } from '../../../utilities/validation';

var formatedValue = function formatedValue(value) {
  return value ? value.toLowerCase().split(' ').map(function (word) {
    return word.charAt(0).toUpperCase() + word.substring(1);
  }).join(' ') : '';
}; // Function to get USPS response from storage


var getUspsResponseFromStorage = function getUspsResponseFromStorage(prefix) {
  var uspsResponseFromStorage = sessionStorage.getItem("".concat(prefix, ".uspsResponse"));
  return uspsResponseFromStorage && uspsResponseFromStorage !== 'undefined' ? uspsResponseFromStorage : null;
};

export var AddressField = function AddressField(_ref) {
  var id = _ref.id,
      labelPrefix = _ref.labelPrefix,
      countryProps = _ref.countryProps,
      addr1Help = _ref.addr1Help,
      stateProps = _ref.stateProps,
      field = _ref.field,
      labelPrefixOnlyForAddressLines = _ref.labelPrefixOnlyForAddressLines,
      tradingApiUrl = _ref.tradingApiUrl,
      apiToken = _ref.apiToken;
  var value = field.value;

  var country = _.get(value, "".concat(id, ".country"));

  var uspsResponse = getUspsResponseFromStorage(id);
  var context = useFormikContext();
  var debounceTimerRef = useRef(null);
  var uspsResponseValues, city, state, zip5, zip4, postalCode, uspsAddress1, uspsAddress2;

  if (uspsResponse) {
    uspsResponseValues = JSON.parse(uspsResponse);
    city = formatedValue(uspsResponseValues.city);
    state = uspsResponseValues.state;
    zip5 = formatedValue(uspsResponseValues.zip5 || '');
    zip4 = formatedValue(uspsResponseValues.zip4 || ''); // Combine zip5 and zip4 into postalCode format (zip5-zip4)

    postalCode = zip4 ? "".concat(zip5, "-").concat(zip4) : zip5;
    uspsAddress1 = formatedValue(uspsResponseValues.uspsAddress1 || ''); // New API doesn't return address2 separately, so it will be null or undefined

    uspsAddress2 = uspsResponseValues.uspsAddress2 ? formatedValue(uspsResponseValues.uspsAddress2) : '';
  } // Check if an error is a USPS formatting error


  var isUspsFormattingError = function isUspsFormattingError(error) {
    return !!error && error.includes('Please utilize the USPS provided formatting');
  }; // Get USPS formatting errors to display after the button


  var getUspsFormattingErrors = function getUspsFormattingErrors() {
    var errors = [];
    var address1Error = context.errors && context.errors["".concat(id, ".address1")];
    var address2Error = context.errors && context.errors["".concat(id, ".address2")];

    if (isUspsFormattingError(address1Error)) {
      errors.push(address1Error);
    }

    if (isUspsFormattingError(address2Error)) {
      errors.push(address2Error);
    }

    return errors;
  };

  var uspsFormattingErrors = getUspsFormattingErrors(); // Debounced USPS validation effect

  useEffect(function () {
    // Only run if trading API URL is provided
    if (!tradingApiUrl) {
      return;
    } // Get current address values from form


    var address1 = _.get(context.values, "".concat(id, ".address1"));

    var address2 = _.get(context.values, "".concat(id, ".address2"));

    var city = _.get(context.values, "".concat(id, ".city"));

    var state = _.get(context.values, "".concat(id, ".state"));

    var postalCode = _.get(context.values, "".concat(id, ".postalCode"));

    var country = _.get(context.values, "".concat(id, ".country")); // Clear any existing debounce timer


    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    } // Set up debounced validation (500ms)


    debounceTimerRef.current = setTimeout(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var address, prefix;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(address1 && city && state && country === Country.UnitedStatesOfAmerica && state !== StateEnum.PuertoRico && tradingApiUrl)) {
                _context.next = 14;
                break;
              }

              _context.prev = 1;
              address = {
                address1: address1,
                address2: address2,
                city: city,
                state: state,
                postalCode: postalCode,
                country: country
              }; // Use the same prefix format as getUspsResponseFromStorage

              prefix = "".concat(id, ".");
              _context.next = 6;
              return triggerUspsVerification(address, prefix, tradingApiUrl, apiToken);

            case 6:
              // Trigger Formik validation to update error states
              context.validateForm();
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              console.error('Error in debounced USPS validation:', _context.t0);

            case 12:
              _context.next = 15;
              break;

            case 14:
              if ((!address1 || !city) && tradingApiUrl) {
                // Clear USPS storage if fields are cleared
                sessionStorage.setItem("".concat(id, ".uspsResponse"), 'undefined');
              }

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    })), 500); // Cleanup function

    return function () {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_.get(context.values, "".concat(id, ".address1")), _.get(context.values, "".concat(id, ".address2")), _.get(context.values, "".concat(id, ".city")), _.get(context.values, "".concat(id, ".state")), _.get(context.values, "".concat(id, ".postalCode")), _.get(context.values, "".concat(id, ".country")), id, tradingApiUrl, apiToken]);
  var getTextboxFieldProps = useCallback(function (field) {
    var fieldProps = {
      component: TextboxField,
      id: "".concat(id, ".").concat(field),
      defaultLabelId: "address.".concat(field)
    };

    if (field === 'state') {
      fieldProps.defaultLabelId = "address.province";
    }

    var shouldApplyPrefix = !labelPrefixOnlyForAddressLines || field === 'address1' || field === 'address2';

    if (labelPrefix && shouldApplyPrefix) {
      fieldProps.labelPrefix = labelPrefix;
    } // Suppress USPS formatting errors for address1 and address2 fields
    // They will be displayed after the button instead


    if ((field === 'address1' || field === 'address2') && context.errors) {
      var fieldError = context.errors["".concat(id, ".").concat(field)];

      if (isUspsFormattingError(fieldError)) {
        fieldProps.suppressError = true;
      }
    }

    return fieldProps;
  }, [id, labelPrefix, labelPrefixOnlyForAddressLines, context.errors]);

  var showUseProvidedButton = function showUseProvidedButton() {
    return context.errors && (uspsAddress1 && context.errors["".concat(id, ".address1")] || uspsAddress2 && context.errors["".concat(id, ".address2")] || city && context.errors["".concat(id, ".city")] || state && context.errors["".concat(id, ".state")] || postalCode && context.errors["".concat(id, ".postalCode")]);
  };

  return React.createElement(React.Fragment, null, React.createElement(FormGroup, null, React.createElement(Field, Object.assign({
    component: SelectDropdownField,
    id: "".concat(id, ".country")
  }, countryProps, {
    autoComplete: "country"
  }))), React.createElement(FormGroup, {
    help: addr1Help
  }, React.createElement(Field, Object.assign({}, getTextboxFieldProps('address1'), {
    autoComplete: "street-address"
  }))), React.createElement(FormGroup, null, React.createElement(Field, Object.assign({}, getTextboxFieldProps('address2'), {
    autoComplete: "address-line2"
  }))), React.createElement(FormGroup, null, React.createElement(Field, Object.assign({}, getTextboxFieldProps('city'), {
    autoComplete: "address-level2"
  }))), React.createElement(FormGroup, null, (country === Country.UnitedStatesOfAmerica || country === '') && React.createElement(React.Fragment, null, React.createElement(Field, Object.assign({
    component: SelectDropdownField,
    id: "".concat(id, ".state")
  }, stateProps, {
    autoComplete: "address-level1"
  }))), country !== Country.UnitedStatesOfAmerica && country !== '' && React.createElement(React.Fragment, null, React.createElement(Field, Object.assign({}, getTextboxFieldProps('state'), {
    autoComplete: "address-level1"
  })))), React.createElement(FormGroup, null, React.createElement(Field, Object.assign({}, getTextboxFieldProps('postalCode'), {
    autoComplete: "postal-code"
  }))), showUseProvidedButton() && React.createElement(FormGroup, null, React.createElement("button", {
    className: "btn btn-block btn-outline-warning",
    onClick: function onClick(e) {
      e.preventDefault();
      console.log('Use USPS Address button clicked:', {
        uspsAddress1: uspsAddress1,
        uspsAddress2: uspsAddress2,
        city: city,
        state: state,
        postalCode: postalCode,
        uspsResponseValues: uspsResponseValues
      });

      var updatedValues = _.cloneDeep(context.values); // Always update all address fields when using USPS provided address
      // This ensures fields are updated even if they don't have errors
      // and clears address2 if USPS doesn't provide it


      if (uspsAddress1) {
        _.set(updatedValues, "".concat(id, ".address1"), uspsAddress1);
      } // Set address2 to the USPS value (or empty string if not provided)
      // Note: New API doesn't return address2 separately, so it will be empty


      _.set(updatedValues, "".concat(id, ".address2"), uspsAddress2 || '');

      if (city) {
        _.set(updatedValues, "".concat(id, ".city"), city);
      }

      if (state) {
        _.set(updatedValues, "".concat(id, ".state"), state);
      }

      if (postalCode) {
        _.set(updatedValues, "".concat(id, ".postalCode"), postalCode);
      }

      console.log('Updated values for address:', {
        address1: _.get(updatedValues, "".concat(id, ".address1")),
        address2: _.get(updatedValues, "".concat(id, ".address2")),
        city: _.get(updatedValues, "".concat(id, ".city")),
        state: _.get(updatedValues, "".concat(id, ".state")),
        postalCode: _.get(updatedValues, "".concat(id, ".postalCode"))
      }); // Update Formik's form values

      context.setValues(updatedValues); // Mark fields as touched to trigger validation

      context.setFieldTouched("".concat(id, ".address1"), true);
      context.setFieldTouched("".concat(id, ".address2"), true);
      context.setFieldTouched("".concat(id, ".city"), true);
      context.setFieldTouched("".concat(id, ".state"), true);
      context.setFieldTouched("".concat(id, ".postalCode"), true); // Trigger validation after a short delay to ensure values are set

      setTimeout(function () {
        context.validateForm();
      }, 100);
    }
  }, "Use USPS provided address"), uspsFormattingErrors.length > 0 && React.createElement("div", {
    style: {
      marginTop: '0.5rem'
    }
  }, uspsFormattingErrors.map(function (error, index) {
    return React.createElement("span", {
      key: index,
      className: "error",
      style: {
        display: 'block'
      }
    }, error);
  }))));
};